import { create } from 'zustand';
import type { Organization } from '../types/organization';

interface OrganizationState {
  organizations: Organization[];
  tree: Organization[];
  selectedOrgId: string | null;
  loading: boolean;
  setOrganizations: (orgs: Organization[]) => void;
  setTree: (tree: Organization[]) => void;
  setSelectedOrg: (id: string | null) => void;
  setLoading: (loading: boolean) => void;
}

export const useOrganizationStore = create<OrganizationState>((set) => ({
  organizations: [],
  tree: [],
  selectedOrgId: null,
  loading: false,
  setOrganizations: (organizations) => set({ organizations }),
  setTree: (tree) => set({ tree }),
  setSelectedOrg: (selectedOrgId) => set({ selectedOrgId }),
  setLoading: (loading) => set({ loading }),
}));
